import {UntypedFormGroup, ValidatorFn} from '@angular/forms';

export const StockValidators: ValidatorFn = (fg: UntypedFormGroup) => {
    const start = fg.get('min_stock').value;
    const end = fg.get('max_stock').value;
    return start !== null && end !== null && start < end
        ? null
        : { stock: true };
};
